import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function DisclaimerPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <main className="pt-20">
        <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <h1 className="text-5xl font-bold text-navy mb-6">
              Disclaimer
            </h1>
            <p className="text-sm text-gray-600">
              Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>
        </section>

        <section className="py-12 pb-24">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <div className="prose prose-lg max-w-none">
              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 mb-10">
                <p className="text-base text-gray-800 font-semibold mb-2">
                  IMPORTANT NOTICE
                </p>
                <p className="text-sm text-gray-700 leading-relaxed">
                  Please read this disclaimer carefully before using our services. By using our services, you acknowledge that you have read, understood, and agree to be bound by this disclaimer.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-navy mb-4">Not a Lender</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                We are not a lender, bank, or financial institution. We do not provide loans, credit, or any form of direct funding. We are a consulting and educational services company that provides funding strategy and business credit consulting services. All funding decisions are made by third-party lenders based on their own criteria.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">No Guarantee of Approvals</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                We do not and cannot guarantee that you will be approved for any specific funding, credit cards, loans, or lines of credit. Approval decisions are made solely by lenders based on their underwriting criteria, which may include but are not limited to credit scores, income, business history, and other factors beyond our control.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Results May Vary</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                Individual results vary significantly based on personal circumstances, credit history, business structure, financial situation, and numerous other factors. Past results of other clients do not guarantee similar outcomes for you. Any testimonials, case studies, or success stories represent individual experiences and should not be considered typical or guaranteed results.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Consulting and Educational Services</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                Our services are consulting and educational in nature. We provide strategic guidance, analysis, and recommendations based on our knowledge and experience. However, we are not providing legal, accounting, or financial advice. You should consult with appropriate licensed professionals for specific advice related to your situation.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Credit Inquiries and Impact</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                Applying for credit, loans, or funding will result in hard inquiries on your credit report, which may temporarily lower your credit score. While we strategically time and sequence applications to minimize impact, you acknowledge that credit inquiries are a normal part of the funding process and accept responsibility for any impact on your credit.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">No Illegal or Unethical Practices</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                We do not engage in, recommend, or condone any illegal or unethical practices including but not limited to credit repair schemes, identity manipulation, false documentation, or misrepresentation to lenders. All our strategies are based on legitimate business practices and compliance with applicable laws and regulations.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Third-Party Relationships</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                We may have relationships with lenders, credit bureaus, or other service providers. However, we are not responsible for the actions, decisions, or policies of these third parties. Any agreements you enter into with third-party lenders or service providers are between you and them.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Timeline Estimates</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                Any timeline estimates we provide are approximations based on typical scenarios and are not guarantees. Actual timelines may be shorter or longer depending on your specific situation, lender processing times, documentation requirements, and other factors beyond our control.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Accuracy of Information</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                While we strive to provide accurate and up-to-date information, lending criteria, regulations, and best practices change frequently. We make no warranties about the completeness, reliability, or accuracy of any information provided. You are responsible for verifying any information before acting on it.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Personal Responsibility</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                You are ultimately responsible for all decisions regarding your finances, credit, and business. Our role is to provide guidance and recommendations, but you must make your own informed decisions. You should carefully consider your financial situation and ability to repay any credit or loans you obtain.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Regulatory Compliance</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                Our services are designed to help you comply with all applicable laws and regulations. However, you are responsible for ensuring your own compliance with all federal, state, and local laws, including but not limited to business licensing, tax obligations, and financial regulations.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Changes to Services</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                We reserve the right to modify, suspend, or discontinue any aspect of our services at any time without prior notice. We are not liable for any modification, suspension, or discontinuance of services.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Contact for Questions</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                If you have any questions about this disclaimer or need clarification on any aspect of our services, please contact us before engaging our services. It is important that you fully understand the nature of our services and the limitations described in this disclaimer.
              </p>

              <div className="bg-navy text-white p-6 rounded-xl mt-10">
                <p className="text-sm leading-relaxed">
                  <strong>By using our services, you acknowledge that you have read this disclaimer, understand it, and agree to be bound by its terms. If you do not agree with any part of this disclaimer, please do not use our services.</strong>
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
